import CloseIcon from "components/icons/icn-close.icon";
import { QuestionMarkIcon } from "components/icons/icn-question-mark.icon";
import { ButtonUnset, DescriptionText } from "components/suggestion-context/styled";
import { TextSpan } from "components/text-label";
import { getFullDateWithTime } from "utils/format-date";
import intl from "react-intl-universal";
import { Content, MainHeader } from "./styled";

interface HeaderContextProps {
  onClose: () => void;
  suggestionCreationDate?: string;
}

const HeaderContext = (props: HeaderContextProps) => {
  const { onClose, suggestionCreationDate } = props;

  return (
    <MainHeader>
      <div>
        <QuestionMarkIcon />
      </div>
      <Content>
        <TextSpan
          display="block"
          color="#111827"
          style={{
            whiteSpace: "normal",
            overflowWrap: "break-word",
            wordBreak: "break-word",
            fontSize: "0.875rem",
            fontWeight: 700,
          }}
        >
          {intl.get("stocks.suggestionContext.title")}
        </TextSpan>

        {suggestionCreationDate && (
          <DescriptionText color="#9CA3AF">{`${intl.get("stocks.suggestionContext.generatedAt")} ${getFullDateWithTime(suggestionCreationDate)}`}</DescriptionText>
        )}
      </Content>
      <ButtonUnset onClick={onClose} aria-label={intl.get("stocks.suggestionContext.close")}>
        <CloseIcon />
      </ButtonUnset>
    </MainHeader>
  );
};

export default HeaderContext;
